/**
 * Active contractor scope for profit-center users.
 *
 * When PC staff order on behalf of a contractor, every contractor-scoped API
 * request must carry the x-contractor-org-id header (validated server-side by
 * the effective-org middleware). The app has several fetch layers (apiRequest,
 * the default query fn, the openapi-fetch client), so the active scope lives
 * here as a module singleton they all read, instead of threading a header
 * through every call site.
 *
 * Set exclusively by PcOrderScopeProvider — synchronously with selection
 * changes so requests fired on the next render already carry the header.
 * Always null for contractor users. React Query cache separation is handled
 * separately, by a per-contractor QueryClient in the provider.
 */

export const CONTRACTOR_ORG_HEADER = "x-contractor-org-id";

let activeContractorOrgId: string | null = null;

export function setActiveContractorScope(orgId: string | null): void {
  activeContractorOrgId = orgId;
}

export function getActiveContractorScope(): string | null {
  return activeContractorOrgId;
}

/** Headers for the active scope; empty when not acting for a contractor. */
export function contractorScopeHeaders(): Record<string, string> {
  return activeContractorOrgId
    ? { [CONTRACTOR_ORG_HEADER]: activeContractorOrgId }
    : {};
}
